import React from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import dayjs from 'dayjs';
import './index.css';
import { useNavigate } from 'react-router-dom';
import { status_type } from '@constants/sessionSiteConstant';
import Delete from '../../../../assets/svg_main/delete.svg';
import { dateFormate } from '@constants/index';

const SessionEvents = ({ eventsData = [], selectedDate, colors, setShowWarningModal, setSessionStatusType, setSessionId }: any) => {
  const navigate = useNavigate();
  const getBorderColor = (eventType: any) => {
    if (eventType === 'vhnd') {
      return colors.vhnd;
    } else if (eventType === 'uhnd') {
      return colors?.uhnd;
    } else if (eventType === 'outreach') {
      return colors?.outreach;
    }
  };

  const getHealthProviders = (event: any) => {
    const providers = event?.health_provider_details?.map((el: any) => {
      return `${el.health_provider_f_name} ${el?.health_provider_l_name}`;
    });
    return providers?.join(', ');
  };

  const handleViewpage = (sessionId: any) => {
    navigate(`/VHND/view/${sessionId}`);
  };

  const handleDeleteSessionWarning = (event: any, sessionId: any) => {
    event.stopPropagation();
    setSessionStatusType('delete');
    setShowWarningModal(true);
    setSessionId(sessionId)
  };

  return (
    <>
      <div className="sessionList">
        <div className="sessionTitle">
          {dayjs(selectedDate).format(dateFormate.dd_mm_yyyy)}
        </div>

        <p className="sessionDetailsLabel">Session Details here</p>
        <div className="sessionListContainer">
          {eventsData?.length > 0 ? (
            eventsData?.map((event: any, index: any) => {
              return (
                <div
                  className="sessionCard"
                  key={index}
                  style={{
                    borderLeft: `4px solid ${getBorderColor(event?.session_type_code)}`,
                  }}
                  onClick={() => handleViewpage(event?.session_id)}
                >
                  <div className='session_Name_Status'>
                    <b>{event?.session_name}</b>
                    {event?.session_status_code == status_type.cancle.session_status_code &&
                      <div className='status_box'>
                        <span className='statusbadges'>{event?.session_status_name}</span>
                        <span onClick={($event: any) => handleDeleteSessionWarning($event, event?.session_id)}><Delete /></span>
                      </div>}
                  </div>
                  <div>
                    <span className="sessionLabel">Scheduled at - </span>
                    {event.session_scheduled_at}
                  </div>
                  <div>
                    <span className="sessionLabel">Health Providers - </span>
                    {getHealthProviders(event)}
                  </div>
                </div>
              );
            })
          ) : (
            <div
              style={{
                margin: '13px 13px',
                fontStyle: 'italic',
                fontSize: 'small',
              }}
            >
              No Session available
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default SessionEvents;
